/* eslint max-classes-per-file: 0 */

import {
  Report as Data,
  ReportCollection as Collection,
} from '@/typings/api/Report'
import { ReportsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class ReportsLKTransformerParams extends TransformerParams {
  public getAll(payload: Record<string, unknown>, rawParams: Record<string, unknown>) {
    const result = super.getAll(payload, rawParams)
    const p = result.params as Record<string, Record<string, unknown>>

    const params = {
      type: 'roadmap',
      ...p,
    }

    return { ...result, params }
  }
}

export class LKReportsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new ReportsLKTransformerParams();
}
